class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    const contents = document.querySelectorAll(".mega-menu__content");
    this.header = document.querySelector(".header-wrapper");
    this.summary = this.mainDetailsToggle.querySelector("summary");
    this.siblingDisclosures = this.closest("ul.list-menu").querySelectorAll("header-menu details");

     
    hoverintent(this.mainDetailsToggle, 
      this.onMouseEnter.bind(this), 
      this.onMouseLeave.bind(this)).options({
      sensitivity: 100, // The maximum distance the cursor can move within the element for it to be considered a hover (default: 7 pixels).
      timeout: 200 //The delay before triggering the out event after the cursor leaves the element (default: 0 milliseconds).
      //interval: The interval at which the library checks the cursor position (default: 100 milliseconds).
      //handleFocus: Whether to trigger events when the element gains or loses focus (default: false).
    }); 

  }

  onMouseEnter(evt) { 
    this.siblingDisclosures.forEach((disclosure) => {
      disclosure.removeAttribute("open");
    });
    this.mainDetailsToggle.setAttribute("open", true);
  }

  onMouseLeave(evt) {
    setTimeout(() => {
      this.mainDetailsToggle.removeAttribute("open"); 
    }, 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue("--header-bottom-position-desktop") !== "") return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
